import { COLORS } from '@/config/colors';
import { css, fillOutlined, circle, shade } from './draw-utils';
import type { ProceduralDef } from '../types';

const CHITIN = 0x7a8a3a; // sickly chitin green
const JOINT = 0xe8d24a; // glowing weak-point joint

/** Broodworm head — armored maw. docs/02 boss pool (single-worm B4). */
export const bossBroodwormHead: ProceduralDef = {
  key: 'boss/broodworm/head',
  width: 96,
  height: 96,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 1,
  draw(ctx, w, h) {
    const c = w / 2;
    circle(ctx, c, c, 40);
    fillOutlined(ctx, shade(CHITIN, 1.1), 5);
    // Plated brow
    ctx.beginPath();
    ctx.arc(c, c, 40, Math.PI * 1.15, Math.PI * 1.85);
    ctx.lineTo(c, c);
    ctx.closePath();
    ctx.fillStyle = css(shade(CHITIN, 0.7));
    ctx.fill();
    // Maw
    circle(ctx, c, c + 6, 16);
    fillOutlined(ctx, COLORS.dangerRed, 3);
    ctx.fillStyle = css(0x1a0f0f);
    for (let i = 0; i < 6; i++) {
      const a = (Math.PI * 2 * i) / 6;
      ctx.beginPath();
      ctx.moveTo(c + Math.cos(a) * 16, c + 6 + Math.sin(a) * 16);
      ctx.lineTo(c + Math.cos(a + 0.2) * 8, c + 6 + Math.sin(a + 0.2) * 8);
      ctx.lineTo(c + Math.cos(a - 0.2) * 8, c + 6 + Math.sin(a - 0.2) * 8);
      ctx.closePath();
      ctx.fill();
    }
    // Eyes
    ctx.fillStyle = css(JOINT);
    circle(ctx, c - 14, c - 12, 5); ctx.fill();
    circle(ctx, c + 14, c - 12, 5); ctx.fill();
    void h;
  },
};

/** Broodworm body segment — the glowing JOINT is the weak point. */
export const bossBroodwormSegment: ProceduralDef = {
  key: 'boss/broodworm/segment',
  width: 84,
  height: 84,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 1,
  draw(ctx, w, h) {
    const c = w / 2;
    circle(ctx, c, c, 34);
    fillOutlined(ctx, CHITIN, 5);
    // Armor plate over the top half
    ctx.beginPath();
    ctx.arc(c, c, 34, Math.PI, 0, false);
    ctx.closePath();
    ctx.fillStyle = css(shade(CHITIN, 0.72));
    ctx.fill();
    // Exposed glowing joint ring (the weak point)
    circle(ctx, c, c, 15);
    fillOutlined(ctx, JOINT, 3);
    circle(ctx, c, c, 7);
    ctx.fillStyle = css(shade(JOINT, 1.3));
    ctx.fill();
    void h;
  },
};
